import Image from './Image';
import Unavailable from './Unavailable';
import PinchPanZoom from './PinchPanZoom';

const MapImage = ({url, loading, onLoad, ...props}) => {
    const Child = url ? Image : Unavailable;

    return (
        <PinchPanZoom loading={loading} disabled={url === null} onLoad={onLoad}>
            {onLoad => <Child {...props} onLoad={onLoad} url={url} />}
        </PinchPanZoom>
    );
};

export default MapImage;
